"use client"
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ProxyServer from './ProxyServer';

const ProxiesTabs = () => {
  return (
    <div className="container mt-4">
      <Tabs defaultActiveKey="tab1" id="proxies-tabs" className="mb-3 border-0 justify-content-center">
        <Tab eventKey="tab1" title="Semi Dedicated Proxies">
           <ProxyServer rawSlug="proxies-semi-dedicated" id=""/>
        </Tab>
        <Tab eventKey="tab2" title="Dedicated Proxies">
        <ProxyServer rawSlug="proxies-dedicated" id=""/>
        </Tab> 
      </Tabs>
    </div>
  );
};

export default ProxiesTabs;
